import { Outlet } from "react-router-dom";
import Header from "../../../features/marketing/shared/Header.jsx";
import Footer from "../../../features/marketing/shared/Footer.jsx";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-warm-50)]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}